module.exports = __webpack_public_path__ + "img/icon-blogroll2.9d4c723c.png";